import RatioIcon1 from '../../assets/svg/1-1.svg?react';
import RatioIcon2 from '../../assets/svg/2-3.svg?react';
import RatioIcon3 from '../../assets/svg/3-2.svg?react';
import RatioIcon4 from '../../assets/svg/4-5.svg?react';
import RatioIcon5 from '../../assets/svg/5-4.svg?react';
import RatioIcon6 from '../../assets/svg/9-16.svg?react';
import RatioIcon7 from '../../assets/svg/16-9.svg?react';
import RatioIcon8 from '../../assets/svg/21-9.svg?react';

const FJImageExtenderData = {
    RATIO_LIST: [
        {
            name: 'original',
            value: 1,
            icon: RatioIcon1,
        },
        {
            name: '1:1',
            value: 1,
            icon: RatioIcon1,
        },
        {
            name: '16:9',
            value: 16 / 9,
            icon: RatioIcon7,
        },
        {
            name: '9:16',
            value: 9 / 16,
            icon: RatioIcon6,
        },
        {
            name: '2:3',
            value: 2 / 3,
            icon: RatioIcon2,
        },
        {
            name: '3:2',
            value: 3 / 2,
            icon: RatioIcon3,
        },
        {
            name: '4:5',
            value: 4 / 5,
            icon: RatioIcon4,
        },
        {
            name: '5:4',
            value: 5 / 4,
            icon: RatioIcon5,
        },
        {
            name: '21:9',
            value: 21 / 9,
            icon: RatioIcon8,
        },
    ],

    IMAGE_NUMBER_LIST: [
        {
            value: 1,
            text: '1',
        },
        {
            value: 2,
            text: '2',
        },
        {
            value: 3,
            text: '3',
        },
        {
            value: 4,
            text: '4',
        },
    ],

    IMAGE_MAX_EXTENDER_DISTANCE: 2000,
};

export default FJImageExtenderData;
